export default __webpack_public_path__ + "static/media/green_arrow.67b239fc.svg";